@defer (when !isLoading()) {
	@if(isLoadingFulfillment){
		<p>Loading fulfillment .....</p>
	} @else {
		<p>Loaded fullfilment!</p>
	}
	<p>Loaded Attributes</p>
} @placeholder {
	<plp-components-skeleton-fulfillment-attribute-section>
	</plp-components-skeleton-fulfillment-attribute-section>
}
